import { DrawingProvider } from '@pn/services/drawing';
import { ConfirmationDialogStateProvider } from '@pn/ui/context-components/ConfirmationDialog';
import { WorkspaceItemPanelProvider } from '@pn/ui/workspace/WorkspaceItemPanelProvider';
import React from 'react';
import { StockChartRangeStateProvider } from './components/StockChartRange';
import { BOEIntelStateProvider } from './contexts/useBOEIntel';
import { UIStateProvider } from './contexts/useUIState';

type ReactProvider = React.ComponentType<{ children: React.ReactNode }>;
type Props = {
  children: React.ReactNode;
};

export function ReactContextsProvider({ children }: Props) {
  const providers: ReactProvider[] = [
    WorkspaceItemPanelProvider,
    ConfirmationDialogStateProvider,
    BOEIntelStateProvider,
    StockChartRangeStateProvider,
    DrawingProvider,
    UIStateProvider,
  ];

  return composeProviders(providers, children);
}

function composeProviders(
  providers: ReactProvider[],
  children: React.ReactNode
): React.ReactNode {
  return providers.reduceRight(
    (kids, Provider) => <Provider>{kids}</Provider>,
    children
  );
}
